import { FilledButton } from '../util/button';
import '../util/bpUtilStyle.css';

interface ChangeCheckInDialogCardProps {
  onClick: () => void;
}
export const ChangeCheckInDialogCard = ({
  onClick,
}: ChangeCheckInDialogCardProps) => {
  const dialogLabel = '入庫日を変更しました';
  const dialogText = ['入庫日の予約変更を承りました'];

  const handleClickConfirm = () => onClick();

  return (
    <div className={'dialog-card'}>
      <div className={'message-field'}>
        <div className={'message-header'}>
          <span>{dialogLabel}</span>
        </div>
        <div className={'message-body'}>
          {dialogText.map((item, idx) => (
            <span key={idx}>{item}</span>
          ))}
        </div>
      </div>
      <FilledButton onClick={handleClickConfirm} label={'予約内容を確認する'} />
    </div>
  );
};
